import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d7ab2de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Group: ")
const _hoisted_2 = { class: "editable" }

import { Group } from "@/models/Group";
import { computed, nextTick, ref } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  required: { type: Boolean, required: false, default: false },
  modelValue: { type: Group, required: false },
  editOnly: { type: Boolean, required: false, default: false},
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef

const editing = ref(props.editOnly);
const editor = ref();

const startEdit = async () => {
  editing.value = true;
  await nextTick();
  //editor.value.focus();
};
const endEdit = () => {
  if (! props.editOnly) editing.value = false;
};

const valid = computed(() => {
  return !props.required || group.value != undefined;
});
const group = computed({
  get: () => props.modelValue,
  set: (value: Group | undefined) => {
    emit("update:modelValue", value);
  },
});

const name = computed(() => {
  if (props.modelValue) return props.modelValue.name;
  else return "<No Group>";
});
const messages = props.required ? "Required" : "";
const select = (newGroup: Group) => {
  let g = undefined;
  if (newGroup) {
    g = groups.value.find((e) => e.id == newGroup.id);
  }
  group.value = g;
  if (!props.editOnly) editing.value = false;
};

const groups = ref<Group[]>([]);
const fetchGroups = async () => {
  groups.value.length = 0;
  groups.value.push(...(await Group.MyGroups()));
};
fetchGroups();

return (_ctx: any,_cache: any) => {
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.editOnly)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: startEdit,
          class: "groupName"
        }, [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(name)), 1)
        ], 512)), [
          [_vShow, !editing.value]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_va_select, {
      options: groups.value,
      "text-by": "name",
      "track-by": "id",
      label: "Group",
      modelValue: _unref(group),
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_isRef(group) ? (group).value = $event : null)),
        select
      ],
      onKeypress: _withKeys(endEdit, ["esc"]),
      ref_key: "editor",
      ref: editor,
      clearable: "",
      "clear-value": undefined,
      "no-options-text": "No Groups Defined"
    }, null, 8, ["options", "modelValue", "onKeypress"]), [
      [_vShow, editing.value]
    ])
  ], 64))
}
}

})